module.exports = __webpack_public_path__ + "img/alter-ego-palette_en.1aecea7.jpg";